import { render, staticRenderFns } from "./assignment_view.vue?vue&type=template&id=52ee6c7e&scoped=true&"
import script from "./assignment_view.vue?vue&type=script&lang=js&"
export * from "./assignment_view.vue?vue&type=script&lang=js&"
import style0 from "./assignment_view.vue?vue&type=style&index=0&id=52ee6c7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ee6c7e",
  null
  
)

export default component.exports